export const VACATION_TEAM_CALENDAR_MONTH_UNIT = 'month';
export const VACATION_TEAM_CALENDAR_PLACEHOLDER_PREFIX = 'vacation-calendar-placeholder-';

export const VACATION_TEAM_CALENDAR_CONFIG = {
  DATE_FORMAT: 'YYYY-MM-DD',
  EMPTY_TEXT: '',
  FIRST_INDEX: 0,
  FIRST_ISO_WEEKDAY: 1,
  NEXT_MONTH_STEP: 1,
  PREVIOUS_MONTH_STEP: -1,
  ROLE_NOT_FOUND_INDEX: -1
};

export const VACATION_TEAM_CALENDAR_KEY = {
  CALENDAR_LOAD_ERROR: 'VACATION_TEAM_CALENDAR_LOAD_ERROR',
  GROUPS_LOAD_ERROR: 'VACATION_TEAM_CALENDAR_GROUPS_LOAD_ERROR',
  MAIN_GROUP_MISSING: 'VACATION_TEAM_CALENDAR_MAIN_GROUP_MISSING',
  NO_GROUPS: 'VACATION_TEAM_CALENDAR_NO_GROUPS'
};

export const VACATION_TEAM_CALENDAR_MONTH_KEYS = [
  'JANUARY',
  'FEBRUARY',
  'MARCH',
  'APRIL',
  'MAY',
  'JUNE',
  'JULY',
  'AUGUST',
  'SEPTEMBER',
  'OCTOBER',
  'NOVEMBER',
  'DECEMBER'
];

export const VACATION_TEAM_CALENDAR_WEEKDAY_KEYS = [
  'VACATION_WEEKDAY_MONDAY',
  'VACATION_WEEKDAY_TUESDAY',
  'VACATION_WEEKDAY_WEDNESDAY',
  'VACATION_WEEKDAY_THURSDAY',
  'VACATION_WEEKDAY_FRIDAY',
  'VACATION_WEEKDAY_SATURDAY',
  'VACATION_WEEKDAY_SUNDAY'
];



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/vacation/vacation-team-calendar.constants.ts